module.exports = __webpack_public_path__ + "img/isoleren-btn.6b52ab0d.png";